module.exports = __webpack_public_path__ + "static/media/angle-double-right.3fa366e6.svg";